export const createDayOffFormConstants = {
    siteId: 'Site Id',
    day: 'Day',
};
